var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-completo"},[_c('div',{staticClass:"footer"},[_c('img',{attrs:{"src":require("../../assets/logo-Governo-2025.svg"),"alt":"Logo do Governo"}})]),_c('div',{staticClass:"powered-by-wrapper"},[_c('p',[_vm._v("powered by "),_c('span',[_vm._v("GT4W")])])])])
}]

export { render, staticRenderFns }